var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9375 13.1875C17.9375 13.3698 17.8651 13.5447 17.7361 13.6736C17.6072 13.8026 17.4323 13.875 17.25 13.875C17.0677 13.875 16.8928 13.8026 16.7639 13.6736C16.6349 13.5447 16.5625 13.3698 16.5625 13.1875C16.5602 11.1825 15.7627 9.26026 14.345 7.84251C12.9272 6.42476 11.005 5.62727 8.99999 5.62499H5.56249V9.06249C5.5626 9.19855 5.52234 9.33157 5.4468 9.44473C5.37126 9.55789 5.26385 9.64609 5.13816 9.69817C5.01247 9.75025 4.87415 9.76387 4.74072 9.73729C4.60729 9.71072 4.48474 9.64516 4.38859 9.5489L0.263585 5.4239C0.199664 5.36005 0.148954 5.28422 0.114357 5.20076C0.0797586 5.1173 0.0619507 5.02784 0.0619507 4.93749C0.0619507 4.84714 0.0797586 4.75768 0.114357 4.67422C0.148954 4.59076 0.199664 4.51494 0.263585 4.45109L4.38859 0.326086C4.48474 0.229828 4.60729 0.164263 4.74072 0.137691C4.87415 0.111119 5.01247 0.124734 5.13816 0.176814C5.26385 0.228894 5.37126 0.317096 5.4468 0.430254C5.52234 0.543413 5.5626 0.676439 5.56249 0.812492V4.24999H8.99999C11.3696 4.25249 13.6414 5.19493 15.317 6.87049C16.9926 8.54605 17.935 10.8179 17.9375 13.1875Z",
    fill: "#5F5F5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowimg);
export default __webpack_public_path__ + "static/media/arrowimg.c49807bdeaaa0df10c820640bad23a23.svg";
export { ForwardRef as ReactComponent };